export default "__VITE_ASSET__DzgmhgbN__"